import { LoadCssResolver, LoadScriptResolver } from '@b2b/common/resolvers';
import { ApiService } from '@b2b/common/services/api/types';
import { TODO } from '@b2b/types/core';
import uiRouter, { StateParams, StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { ProgramsInstanceControllerModule } from './controllers/ProgramsInstanceController';
import { ProgramsInstanceEditView } from './edit/edit';

export const ProgramsInstanceView = angular
  .module('acme.view.application.programs.instance', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.helpers',
    ProgramsInstanceControllerModule,
    ProgramsInstanceEditView,
    'acme.common.directive.pageHeader',
    'acme.common.directive.resourceType',
    'acme.common.directive.relink',
    'acme.view.application.resources.modals.assign.controllers',
    'acme.view.application.programs.modals.rescheduleEvent.controllers',
    'acme.view.application.programs.modals.confirmUpdateEvent.controllers',
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.programsInstance',
      url: '/programs/instance/:id',
      views: {
        'subview-main': {
          controller: 'ProgramsInstanceController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/programs/instance/instance.tpl.html',
        },
      },
      data: {
        pageTitle: 'Event Details',
        permissions: ['EVENT_VIEW'],
      },
      resolve: {
        EventInstance: [
          '$stateParams',
          'ApiService',
          function ($stateParams: StateParams, ApiService: ApiService) {
            return ApiService.event.detail($stateParams.id);
          },
        ],
        DiscountCodesData: [
          'ApiService',
          'HelpersService',
          function (ApiService: ApiService, HelpersService: TODO) {
            return ApiService.discounts.list('v2', HelpersService.getPaginator());
          },
        ],
        selectizeCSS: LoadCssResolver({ id: 'selectize-css', url: '/assets/selectize.bootstrap3.css' }),
        formRender: LoadScriptResolver({ id: 'form-render-js', url: '/assets/form-render.min.js' }),
        formRenderCss: LoadCssResolver({ id: 'form-render', url: '/assets/form-render.min.css' }),
      },
    });
  }).name;
